// import http from '../utils/http'
const process1 = {
	id: 1,
	name: '开店',
	description: '描述1',
	role: '店员',
	roleIds: '1',
	cycle: 'day',
	cycleL: '每天',
	time: '09:30'
}
const process2 = {
	id: 2,
	name: '闭店',
	description: '描述1',
	role: '店员,店长',
	roleIds: '|1|2|',
	cycle: 'day',
	cycleL: '每天'
}
const role1 = {
	id: 1,
	name: '店员'
}
const role2 = {
	id: 2,
	name: '店长'
}
const tasks = [
	{
		id: 1,
		name: '开机',
		description: '描述1',
		process_id: 1
	},
	{
		id: 2,
		name: '检查客服手机是否留言',
		description: '描述1',
		process_id: 1
	},
	{
		id: 3,
		name: '上架甜品、面包、饮料',
		description: '描述1',
		process_id: 1
	},
	{
		id: 4,
		name: '关机',
		description: '描述1',
		process_id: 2
	},
	{
		id: 5,
		name: '清洁工作',
		description: '描述1',
		process_id: 2
	}
]
export default {
	searchProcess(params, cb) {
		this.http.get(`/sop/searchProcess`, { params }).then((r) => {
			cb(r)
		})
	},
	getProcessById(id, cb, ecb) {
		this.http
			.get(`/sop/getProcessById/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateProcess(form, cb, ecb) {
		this.http
			.post(`/sop/updateProcess`, form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	createProcessInstance(params, cb, ecb) {
		this.http
			.post(`/sop/createProcessInstance`, params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchProcessInstance(params, cb) {
		// cb({
		// 	total: 2,
		// 	objects: [
		// 		{
		// 			id: 1,
		// 			process_id: 1,
		// 			status: 'running',
		// 			start_time: '2021-03-01 09:30',
		// 			end_time: '2021-03-01 10:30'
		// 		},
		// 		{
		// 			id: 2,
		// 			process_id: 1,
		// 			status: 'running',
		// 			start_time: '2021-03-02 09:30'
		// 		}
		// 	]
		// })
		// return
		this.http.get(`/sop/searchProcessInstance`, { params }).then((r) => {
			cb(r)
		})
	},
	searchTaskInstance(params, cb) {
		cb({
			total: 2,
			objects: [
				{
					id: 1,
					task_id: 1,
					processProcess_id: 1,
					status: 'done',
					start_time: '2021-03-01 09:30',
					end_time: '2021-03-01 10:30'
				},
				{
					id: 2,
					task_id: 2,
					processProcess_id: 1,
					status: 'running',
					start_time: '2021-03-01 10:30'
				}
			]
		})
		return
		this.http.get(`/sop/searchTaskInstance`, { params }).then((r) => {
			cb(r)
		})
	},
	statusTaskInstance(taskInstance_id, tostatus, cb, ecb) {
		this.http
			.post(`/sop/statusTaskInstance/${taskInstance_id}/${tostatus}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchTask(params, cb) {
		alert('searchtask')
		let r = { total: 0, objects: [] }
		let tmp = tasks.filter((t) => t.process_id == params.process_id)
		r.total = tmp.length
		r.objects = tmp
		console.debug('searchTask', r)
		cb(r)
		return
		this.http.get(`/sop/searchTask`, { params }).then((r) => {
			cb(r)
		})
	},
	getTaskById(roleid, cb) {
		this.http.get(`/acl/removeRole/${roleid}`).then((r) => cb(r))
	},
	updateTask(params, cb, ecb) {
		this.http
			.post('/acl/searchRole', params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
